import React, { useState, useEffect, useRef } from "react";
import "../css/dropdown.css";
import { useTranslation } from "react-i18next";

function DropdownComponent({
  title,
  options,
  onSelect,
  selected,
  position = "bottom",
  icon,
}) {
  const [open, setOpen] = useState(false);
  const dropdownRef = useRef(null);
  const { t } = useTranslation();

  const handleSelect = (option) => {
    onSelect(option.value);
    setOpen(false);
  };

  const getPositionStyle = () => {
    switch (position) {
      case "top":
        return { bottom: "100%", left: 0, marginBottom: "4px" };
      case "left":
        return { top: 0, right: "100%", marginRight: "4px" };
      case "right":
        return { top: 0, left: "100%", marginLeft: "4px" };
      case "bottom":
      default:
        return { top: "100%", left: 0, marginTop: "4px" };
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div ref={dropdownRef} className="klerk-dropdown">
      <div className="klerk-dropdown-toggle" onClick={() => setOpen(!open)}>
        {icon && (
          <span style={{ display: "flex", alignItems: "center" }}>{icon}</span>
        )}
        <span className="klerk-dropdown-title">{t(title)}</span>
        <span
          className="klerk-dropdown-arrow"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
        >
          ⌵
        </span>
      </div>

      {open && (
        <div className="klerk-dropdown-menu" style={getPositionStyle()}>
          {options.map((option) => {
            const isSelected = selected
              ? selected.value === option.value
              : option.value === options[0].value;
            return (
              <div
                key={option.value}
                onClick={() => handleSelect(option)}
                className={`klerk-dropdown-item ${isSelected ? "klerk-dropdown-item-selected" : ""}`}
              >
                {option.icon && <span>{option.icon}</span>}
                {t(option.label)}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default DropdownComponent;
